import {routes as adminReports} from './pages/admin-reports'
import {routes as auth} from './pages/auth'
import {routes as excluded} from './pages/blacklists'
import {routes as communities} from './pages/communities'
import {routes as communityConfig} from './pages/community-config/routes'
import {routes as content} from './pages/content'
import {routes as contentCalendar} from './pages/content-calendar'
import {routes as createCommunity} from './pages/create-community'
import {routes as domainAuthentication} from './pages/domain-authentication'
import {routes as domainDeliverability } from './pages/domain-deliverability'
import {routes as drops } from './pages/drops'
import {routes as engagementSummary} from './pages/engagement-summary'
import {routes as feedback} from './pages/feedback'
import {routes as filterGroup} from './pages/filter-group'
import {routes as filterGroups} from './pages/filter-groups'
import {routes as forgotPassword} from './pages/forgot-password'
import {routes as home} from './pages/home'
import {routes as imports} from './pages/imports'
import {routes as importErrors} from './pages/imports/errors'
// import {routes as integrationMappings} from './pages/integration-mappings'
// import {routes as integrationReports} from './pages/integration-reports'
// import {routes as integrations} from './pages/integrations'
import {routes as ipPools} from './pages/ip-pools'
import {routes as leadText} from './pages/lead-text/routes'
import {routes as login} from './pages/login'
import {routes as logout} from './pages/logout'
import {routes as member} from './pages/member-details'
import {routes as members} from './pages/members'
import {routes as newsbrief} from './pages/newsbrief'
import {routes as newsbriefCounts} from './pages/newsbrief-counts'
import {routes as oauthLogin} from './pages/oauth-login'
import {routes as referralCampaigns} from './pages/referral-campaigns/routes'
import {routes as reports} from './pages/reports'
import {routes as resetPassword} from './pages/reset-password'
import {routes as schedules} from './pages/schedules'
import {routes as source} from './pages/source-config'
import {routes as training} from './pages/training'
import {routes as upcomingSchedules} from './pages/upcoming-schedules'
import {routes as userSettings} from './pages/user-settings'
import {routes as users} from './pages/users'

export const routes = [
  ...adminReports,
  ...auth,
  ...communities,
  ...communityConfig,
  ...content,
  ...contentCalendar,
  ...createCommunity,
  ...domainAuthentication,
  ...domainDeliverability,
  ...drops,
  ...engagementSummary,
  ...excluded,
  ...feedback,
  ...filterGroup,
  ...filterGroups,
  ...forgotPassword,
  ...home,
  ...importErrors,
  ...imports,
  // ...integrationMappings,
  // ...integrationReports,
  // ...integrations,
  ...ipPools,
  ...leadText,
  ...login,
  ...logout,
  ...member,
  ...members,
  ...newsbrief,
  ...newsbriefCounts,
  ...oauthLogin,
  ...referralCampaigns,
  ...reports,
  ...resetPassword,
  ...schedules,
  ...source,
  ...training,
  ...upcomingSchedules,
  ...userSettings,
  ...users,
]



// WEBPACK FOOTER //
// ./src/routes.tsx